export default "__VITE_ASSET__4paQA4eC__"